/**
 * to represent either chat is active or not
 */
export enum ChatStatus {
  Waiting = "waiting",
  Typing = "typing",
  Responded = "responded",
  Error = "error",
}
